module.exports = __webpack_public_path__ + "static/media/european-union.aafa57c9.svg";